<template>
  <div class="page-wraper">
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent> 
    <div class="page-content">
      <!-- Banner  -->
      <div
        class="dz-bnr-inr dz-bnr-inr-sm text-center overlay-primary-dark"
        style="background-image: url(assets/images/banner/bnr1.jpg)"
      >
        <div class="container">
          <div class="dz-bnr-inr-entry">
            <h1>{{ pageContent.contact_us }}</h1>
            <nav aria-label="breadcrumb" class="breadcrumb-row m-t15">
              <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="index.html">{{ pageContent.home }}</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  {{ pageContent.contact_us }}
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <!-- Banner End -->

      <!-- Map Iframe -->
      <section class="map-wrapper1 overflow-hidden content-inner">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-xl-7 col-lg-7 col-sm-12 m-b30">
              <div class="form-wrapper style-1">
                <h2 class="title m-a0">{{ pageContent.get_in_touch }}</h2>
                <p class="font-text text-primary p-b10">
                  {{ pageContent.help_text }}
                </p>
                <div class="contact-area">
                  <form @submit.prevent="submitContactForm">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="input-group">
                          <input
                            v-model="form.firstName"
                            required
                            type="text"
                            class="form-control"
                            :placeholder="pageContent.first_name"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <input
                            v-model="form.lastName"
                            required
                            type="text"
                            class="form-control"
                            :placeholder="pageContent.last_name"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <input
                            v-model="form.email"
                            required
                            type="email"
                            class="form-control"
                            :placeholder="pageContent.email_address"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <input
                            v-model="form.phone"
                            required
                            type="text"
                            class="form-control"
                            :placeholder="pageContent.mobile_no"
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="input-group">
                          <textarea
                            v-model="form.message"
                            rows="5"
                            required
                            class="form-control"
                            :placeholder="pageContent.type_message"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="g-recaptcha"
                          data-sitekey="6LcPCcoqAAAAAAGqh6P5wzdlfLNOVJyGltzB5jWi"
                        ></div>
                      </div>
                      <div class="col-md-12 p-t20">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          :disabled="isLoading"
                        >
                          {{ isLoading ? pageContent.sending: pageContent.submit_now}}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-lg-5 m-b30">
              <div class="info-box style-1">
                <div class="info">
                  <h2 class="text-light">{{pageContent.get_in_touch}}</h2>
                  <p class="text-white">
                    {{pageContent.form_note}}<br>
                    {{pageContent.form_note2}}
                  </p>
                </div>
                <div class="widget widget_getintuch">
                  <ul>
                    <li>
                      <div class="d-flex align-items-center">
                        <span class="text-light">{{pageContent.email_us}}</span>
                      </div>
                      <p class="m-a0 p-t10">
                        {{pageContent.support_text}}
                      </p>
                      <h6 class="text-light">
                        {{pageContent.support_email}}</h6>
                    </li>
                  </ul>
                </div>
                <div class="dz-social style-1">
                  <h6 class="text-light">{{pageContent.socials}}</h6>
                  <ul class="social-icon">
                    <li>
                      <a
                        class="social-btn"
                        target="_blank"
                        href="https://www.facebook.com/explore2teach/"
                        ><i class="fa-brands fa-facebook-f"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="social-btn"
                        target="_blank"
                        href="https://www.instagram.com/explore2teach/"
                        ><i class="fa-brands fa-instagram"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="social-btn"
                        target="_blank"
                        href="https://linkedin.com/explore2teach"
                        ><i class="fa-brands fa-linkedin"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Map Iframe End -->
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
import axios from "axios";
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      form: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      },
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
      isLoading: false,
    };
  },
  mounted() {
    // Wait for reCAPTCHA to load
    const checkGrecaptcha = setInterval(() => {
      if (typeof window.grecaptcha !== "undefined") {
        clearInterval(checkGrecaptcha);
        console.log("reCAPTCHA loaded successfully.");
      } else {
        console.log("reCAPTCHA not loaded .");
      }
    }, 2000);

    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    async submitContactForm() {
      this.isLoading = true;

      try {
        if (typeof window.grecaptcha === "undefined") {
          alert(
            "reCAPTCHA is not yet ready. Please try again in a few seconds."
          );
          this.isLoading = false;
          return;
        }

        const recaptchaToken = window.grecaptcha.getResponse();
        console.log(recaptchaToken)
        if (!recaptchaToken) {
          alert("Please complete the reCAPTCHA.");
          this.isLoading = false;
          return;
        }

        const response = await axios.post(
          "https://sendcontactemail-ujliha62qa-uc.a.run.app",
          { ...this.form, recaptchaToken },
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.status === 200) {
          alert("Message sent successfully!");
          this.form = {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            message: "",
          };
          window.grecaptcha.reset();
        } else {
          alert(`Error: ${response.data.message}`);
        }
      } catch (error) {
        console.error("Error sending message:", error);
        alert("Failed to send message.");
      } finally {
        this.isLoading = false;
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.contact[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>